<template>
  <div class="footer">
    <p>中共中央政法委员会主办 网站编辑部信箱：changanwang@126.com</p>
    <p>Copyright 2015 www.chinapeace.gov.cn All Rights Reserved 京ICP备 14028866 号-1 &nbsp;&nbsp; 中国长安网 &copy; 2017版权所有</p>
  </div>
</template>
<script>
export default {
  name: "changanFooter",
  data() {
    return {};
  },
  mounted() {}
};
</script>
<style scoped>
.footer {
  background-color: rgb(51, 102, 204);
  color: #ffffff;
  width: 1280px;
  height: 50px;
  margin: 0px auto;
  padding: 50px 0;
  text-align: center;
}
.el-footer {
  padding:0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/changanFooter.vue